import "../../vendor/quantum-v2.4.0-202408090001/assets/js/vendors/choices.js-10.2.0/public/assets/scripts/choices.min";
import Quill from "../../vendor/quantum-v2.4.0-202408090001/assets/js/vendors/quill-1.3.7/dist/quill.min";
import "../../vendor/quantum-v2.4.0-202408090001/assets/release/qn-202408090001";

window.Quill = Quill;
